import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const RovoServiceAgentEntrypoint = createEntryPoint({
    root: JSResourceForInteraction(
        () => import(/* webpackChunkName: "async-rovo-service-agent-entrypoint" */ './embed-widget'),
        {
            moduleId: 'rovo-service-agent-entrypoint',
        }
    ),
    getPreloadProps: () => ({}),
});
